import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../../reduxService';
import { IProjectBaseResponse } from '../../../api/IApiResponse';
/* import * as BeMaccaferriCalculationHelper from '../../api/calculation/BeMaccaferriCalculationHelper'; */
/* import { validateProjectBeforeRun } from '../../../utils/utils'; */
/* import { IProjectMacro1 } from './projectSlice'; */
import { warning } from '../../../../components/Alert/Alert';
import i18n from '../../../localization';
import { unit } from '../../../enum/project';
import { EConversionSIToImperial, convertTo } from '../../../conversion';
import { roundToTwo } from '../../../utils/utils';
import { IMacro1ProjectOutputData } from '../../../api/IApiResponse';
import BeMaccaferriStoreProvider from '../../../api/store/BeMaccaferriStoreProvider';

export interface IProjectMacro1Validation {
    startValidation: boolean;
    anchorBar: boolean;
    anchorBarErrors?: boolean;
    mesh: boolean;
    meshErrors?: boolean;
    rockSlope: boolean;
    rockSlopeErrors?: boolean;
    safetyCoefficients: boolean;
    safetyCoefficientsErrors?: boolean;
    siteEnvironmentalLevel: boolean;
    siteEnvironmentalLevelErrors?: boolean;
}

export interface IProjectMacro1Results {
    outputData?: IMacro1ProjectOutputData;
    validation?: IProjectMacro1Validation;
}

const initialState: IInitialState<IProjectMacro1Results> = {
    initialState: true,
};

export const resultsSlice = createSlice({
    name: 'resultsMacro1',
    initialState,
    reducers: {
        cleanResults: state => {
            state.initialState = true;
            state.data = undefined;
        },
        setOutputData: (state, action: PayloadAction<IMacro1ProjectOutputData>) => {
            state.initialState = false;
            state.data = { ...state.data, outputData: action.payload };
        },
        updateValidation: (state, action: PayloadAction<IProjectMacro1Validation>) => {
            state.initialState = false;
            state.data = { ...state.data, validation: action.payload };
        }
    },
});

export const { cleanResults, setOutputData, updateValidation } = resultsSlice.actions;

export default resultsSlice.reducer;
